export const configImc = {
  type: "bar",
  responsive: true,
  interaction: {
    mode: "index",
    intersect: false,
  },
  plugins: {
    title: {
      display: true,
      text: "Poids - Taille - IMC",
      padding: 20,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      align: "top",
      offset: -5,
      backgroundColor: function (context) {
        return "#3d3d3d";
      },
      borderRadius: 4,
      color: "white",
      font: {
        weight: "bold",
      },
      //formatter: Math.round,
      padding: 6,
    },
  },
  scales: {
    y: {
      type: "linear",
      display: true,
      position: "left",
      grid: {
        drawOnChartArea: true, // only want the grid lines for one axis to show up
      },
      suggestedMin: 0, // ??
      suggestedMax: 2, // ??
    },
    y1: {
      type: "linear",
      display: true,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: false, // only want the grid lines for one axis to show up
      },
    },
    y2: {
      min: 10,
      suggestedMin: 16, // ??
      suggestedMax: 30, // ??
      type: "linear",
      display: false,
      position: "right",
      // grid line settings
      grid: {
        drawOnChartArea: false, // only want the grid lines for one axis to show up
      },
    },
  },
};

export const dataConfigImc = (data) => ({
  labels: data.labels,
  datasets: [
    {
      label: "IMC",
      data: data.imc,
      borderColor: "#3d3d3d",
      backgroundColor: "#3d3d3d",
      yAxisID: "y2",
      type: "line",
      datalabels: { display: true },
    },
    {
      label: "Taille",
      data: data.size,
      borderColor: "#b5cfe0",
      backgroundColor: "#b5cfe0",
      yAxisID: "y",
      type: "bar",
      datalabels: { display: false },
    },
    {
      label: "Poids",
      data: data.weight,
      borderColor: "#baa88a",
      backgroundColor: "#baa88a",
      yAxisID: "y1",
      type: "bar",
      datalabels: { display: false },
    },
  ],
});
